<template>
  <div>
    <notifications-component />
    <router-view />
  </div>
</template>

<script setup>
import NotificationsComponent from "@/components/notificationsComponent.vue";
import '@/assets/styles/global.css';
import '@/assets/styles/setup.css';
</script>
